import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Banner from "template-store/components/banner/banner";
import { withGenericConfig } from "/contexts/generic-config-context";
import TemplateList from "template-store/components/template-list/template-list";
import CategoriesTiles from "template-store/components/categories-tiles/categories-tiles-component";
import { getMostPopularSolutions, getNewAndNotableSolutions } from "template-store/services/solutions-service";
import { getFeaturedCategories } from "template-store/services/solution-categories-service";
import { MOST_POPULAR_CONTEXT, NEW_AND_NOTEABLE_CONTEXT } from "template-store/constants/template-list-context";
import MobileTemplatesNavigation from "template-store/components/mobile-navigation/mobile-navigation-component";
import { HOME_ID } from "template-store/constants/categories";
import { StyledTemplateHomePageContent } from "./template-homepage-content.scss";
const TemplateHomePageContent = (props)=>{
    const { translate, allSolutions, allCategories, onSearchChange } = props;
    return /*#__PURE__*/ _jsxs(StyledTemplateHomePageContent, {
        className: "template-home-page-content-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "banner-wrapper",
                children: /*#__PURE__*/ _jsx(Banner, {
                    title: translate("templateCenter.homepage.bannerTitle"),
                    description: translate("templateCenter.homepage.bannerDescription"),
                    titleTagComponent: "h1",
                    descriptionTagComponent: "h2"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mobile-navigation-wrapper",
                children: /*#__PURE__*/ _jsx(MobileTemplatesNavigation, {
                    allCategories: allCategories,
                    selectedCategoryId: HOME_ID,
                    showSearch: "true",
                    onSearchChange: onSearchChange
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "featured-categories-wrapper",
                children: /*#__PURE__*/ _jsx(CategoriesTiles, {
                    categories: getFeaturedCategories(allCategories),
                    title: translate("templateCenter.homepage.featuredCategories")
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "most-popular-wrapper",
                children: /*#__PURE__*/ _jsx(TemplateList, {
                    solutions: getMostPopularSolutions(allSolutions),
                    title: translate("templateCenter.homepage.mostPopular"),
                    context: MOST_POPULAR_CONTEXT
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "new-and-notable-wrapper",
                children: /*#__PURE__*/ _jsx(TemplateList, {
                    solutions: getNewAndNotableSolutions(allSolutions),
                    title: translate("templateCenter.homepage.newAndNotable"),
                    context: NEW_AND_NOTEABLE_CONTEXT
                })
            })
        ]
    });
};
export default withGenericConfig(TemplateHomePageContent);
